import React from 'react';

const container = (WrappedComponent, { handleExpand, expand }) => ({ index, ...props }) => (
  <WrappedComponent
    {...props}
    isExpand={expand === index}
    onExpand={handleExpand(index)}
  />
);

export default container;



// WEBPACK FOOTER //
// ./src/sections/Stars/container.js